var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowcaseList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.75H2.66667V9.25H8M16 9.25V7.5L15.1111 3.125H0.888889L0 7.5V9.25H0.888889V14.5H9.77778V9.25H13.3333V14.5H15.1111V9.25M15.1111 0.5H0.888889V2.25H15.1111V0.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaseList);
export default __webpack_public_path__ + "static/media/showcaseList.bebb6feef914d33f49fc097e0dbb01a5.svg";
export { ForwardRef as ReactComponent };